import React from "react";
export default function useTempAction() {
    const [list, setList] = React.useState([]);
    const action = React.useMemo(() => (item, promise) => {
        // @ts-expect-error - TS2345 - Argument of type '(l: never[]) => T[]' is not assignable to parameter of type 'SetStateAction<never[]>'.
        setList((l) => [...l, item]);
        promise().finally(() => setList((l) => l.filter((i) => i !== item)));
    }, []);
    return [list, action];
}
